export default __webpack_public_path__ + "static/media/Matter-Medium.dbae57b9.ttf";